import {FlowNodeData, FlowNodeTypes, SettingParamTypes} from "@/types/node";
import {Node} from "@xyflow/react";

export const branchNodeBlueprint: Partial<Node<FlowNodeData>> = {
  type: FlowNodeTypes.BRANCH,
  position: {x: 0, y: 0},
  measured: {height: 38, width: 340},
  data: {
    type: FlowNodeTypes.BRANCH,
    settingsTitle: "New Branch",
    description:
      "Split the conversation by dynamically routing your dialogue through custom branches based on specific conditions.",
    onChange: () => {
      console.log("Start node changed");
    },
    isEmpty: true,
    settings: [
      {
        title: "General",
        description:
          "Split the conversation by dynamically routing your dialogue through custom branches based on specific conditions.",
        params: [
          {
            label: "Branch Name",
            placeholder: "Enter Branch name",
            type: SettingParamTypes.INPUT,
            key: "name",
            value: "",
          },
          {
            label: "Condition Type",
            type: SettingParamTypes.TABS,
            key: "condition_type",
            value: {},
            tabs: [
              {
                title: "Deterministic Rule",
                value: [],
                key: "deterministic",
                settings: [
                  {
                    label: "All Rules Must Be True",
                    type: SettingParamTypes.SWITCH,
                    key: "is_and",
                    value: true,
                  },
                  {
                    type: SettingParamTypes.DETERMINISTIC_CONDITION,
                    key: "rules",
                    value: [],
                  },
                ],
              },
              {
                title: "Prompt",
                value: "",
                key: "prompt",
                settings: [
                  {
                    label: "When to go here",
                    placeholder: "Describe when to take this branch",
                    type: SettingParamTypes.PROMPT,
                    key: "description",
                    value: "",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
};
